"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslations = void 0;
var _react = require("react");
var _context = require("./context");
const useTranslations = () => (0, _react.useContext)(_context.translationsContext);
exports.useTranslations = useTranslations;
//# sourceMappingURL=hooks.js.map